// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"53b9cde4","241":"bfa9cced","421":"21696044","508":"92f62a01","807":"7dd2e2dd","950":"d1de2525"}[chunkId] + ".chunk.css";
};